var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustoms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9568 5.83759L16.4501 1.0607C16.1621 0.940703 15.8376 0.940703 15.5496 1.0607L4.04387 5.83759C3.60565 6.01981 3.32031 6.44737 3.32031 6.92204V12.7291C3.32031 20.7256 8.1532 27.9185 15.5568 30.9407C15.8412 31.0571 16.1594 31.0571 16.4439 30.9407C23.8474 27.9185 28.6803 20.7256 28.6803 12.7291V6.92204C28.6803 6.44737 28.395 6.01981 27.9568 5.83759ZM26.3328 12.7291C26.3328 19.5274 22.3408 25.7851 16.0003 28.578C9.82965 25.8589 5.66787 19.7114 5.66787 12.7291V7.70515L16.0003 3.41537L26.3328 7.70515V12.7291ZM14.7025 16.6865L19.7488 11.6403C20.2074 11.1816 20.9505 11.1816 21.4092 11.6403C21.8679 12.0989 21.8679 12.842 21.4092 13.3007L15.5328 19.1771C15.0741 19.6358 14.331 19.6358 13.8723 19.1771L10.5914 15.8963C10.1328 15.4376 10.1328 14.6945 10.5914 14.2358C11.0501 13.7771 11.7932 13.7771 12.2519 14.2358L14.7025 16.6865Z",
    fill: "#21438E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustoms);
export default __webpack_public_path__ + "static/media/customs.9e34ce3efa2e37bf110ea8beb9a90077.svg";
export { ForwardRef as ReactComponent };